import { AutogenLayoutRetransmitStatusModalOrderSave } from "./autogen/AutogenLayoutRetransmitStatusModalOrderSave";

export class RetransmitStatusModalOrderSave extends AutogenLayoutRetransmitStatusModalOrderSave {
}
